<template>
  <footer
    class="relative w-full bg-[#061328] pt-32 pb-12 px-6 lg:px-20 border-t border-white/5"
  >
    <div class="absolute top-0 left-0 w-full z-40 pointer-events-none -translate-y-1/2">
      <img
        src="@/assets/divider.avif"
        alt="Section Divider"
        class="w-full h-auto min-h-[100px] object-cover"
      />
    </div>

    <div class="max-w-7xl mx-auto">
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-10 lg:gap-4">
        <div class="lg:col-span-6 flex flex-col gap-4">
          <a href="/#home" class="inline-block">
            <img
              src="@/assets/zach_dev_works_logo.avif"
              class="w-auto h-16 object-contain"
              alt="logo"
            />
          </a>
          <p class="text-slate-300 text-sm max-w-[280px] leading-relaxed">
            Game Streamer Website Design & Development
          </p>
        </div>

        <div class="lg:col-span-6 grid grid-cols-2 md:grid-cols-3 gap-8">
          <div class="flex flex-col gap-4">
            <h4 class="text-white font-bold text-sm tracking-wider">Quick Links</h4>
            <nav class="flex flex-col gap-3">
              <a
                v-for="item in navItems"
                :key="item.id"
                :href="getNavHref(item)"
                class="text-slate-400 hover:text-[#1EC3FF] text-sm transition-colors"
              >
                {{ item.name }}
              </a>
            </nav>
          </div>

          <div class="flex flex-col gap-4">
            <h4 class="text-white font-bold text-sm tracking-wider">Contact</h4>
            <nav class="flex flex-col gap-3">
              <a
                href="https://mail.google.com/mail/?view=cm&fs=1&to=dev.zachediaz@gmail.com"
                target="_blank"
                rel="noopener noreferrer"
                class="text-slate-400 hover:text-[#1EC3FF] text-sm transition-colors"
                >Email</a
              >
              <a
                href="https://discord.gg/smky9MMEGH"
                class="text-slate-400 hover:text-[#1EC3FF] text-sm transition-colors"
                >Discord</a
              >
              <!-- <a
                href="#"
                class="text-slate-400 hover:text-[#1EC3FF] text-sm transition-colors"
                >Telegram</a
              > -->
            </nav>
          </div>


        </div>
      </div>

      <div class="mt-16 pt-8">
        <div class="text-slate-500 text-xs tracking-wide">
          © {{ currentYear }} Zach Dev Works. All rights reserved.
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "FooterElement",
  props: {
    activeSection: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      navItems: [
        { id: "services", name: "Services" },
        { id: "features", name: "Features" },
        { id: "house-games", name: "House Games" },
        { id: "projects", name: "Projects" },
        { id: "partners", name: "Partners" },
        { id: "pricing", name: "Pricing" },
        // { id: "contact", name: "Contact" },
      ],
    };
  },
  methods: {
    getNavHref(item) {
      if (item.id === "contact") return "/contact";
      return `#${item.id}`;
    },
  },
  computed: {
    currentYear() {
      return new Date().getFullYear();
    },
  },
};
</script>
